module.exports = __webpack_public_path__ + "img/a1.b631c977.png";